import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { SentryService } from './sentry.service';

export function provideSentry(
  environment: string,
  enabled?: boolean,
  dsn?: string,
): (Provider | EnvironmentProviders)[] {
  if (!(enabled && dsn)) {
    return [];
  }

  return [
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
      const sentryService = inject(SentryService);

      sentryService.initialize(environment, enabled, dsn);
    }),
    {
      deps: [Router],
      provide: Sentry.TraceService,
    },
  ];
}
